import { UserType } from "@mcleod/core";
import { DataSource } from "@mcleod/components";
import { UserTableController  } from "./UserTableController";
import { UserTableLayout } from "./UserTableLayout";
import { AutogenLayoutUserTableDockOperator } from "./autogen/AutogenLayoutUserTableDockOperator";

export class UserTableDockOperator extends AutogenLayoutUserTableDockOperator implements UserTableLayout {
    public getSourceUsers(): DataSource {
        return this.sourceUsers;
    }

    public getUserType(): UserType {
        return UserType.DOCK;
    }

    override onLoad(): void | Promise<void> {
        new UserTableController(this);
        this.tableUsers.generalLayout = "lme/general/user/DockUser";
    }
}
